// The header cart badge and the summary page both need the cart summary and
// both request it when they mount, so one page load used to fire the same GET
// twice. Callers that start the same request while one is still in flight
// share it. A caller may also ask to reuse a request that settled a moment
// ago (`reuseMs`): the page chunks load lazily (ADR-0022), so the summary page
// often mounts just after the header's request has already answered. A call
// without `reuseMs` — a refresh after a cart change — always starts fresh.
const entries = new Map();

export const shareInFlight = (key, start, { reuseMs = 0 } = {}) => {
    const entry = entries.get(key);
    if (entry) {
        if (entry.settledAt === null) return entry.promise;
        if (reuseMs > 0 && Date.now() - entry.settledAt < reuseMs) return entry.promise;
    }

    const next = { promise: null, settledAt: null };
    next.promise = Promise.resolve()
        .then(start)
        .then(
            (value) => {
                if (entries.get(key) === next) next.settledAt = Date.now();
                return value;
            },
            (error) => {
                if (entries.get(key) === next) entries.delete(key);
                throw error;
            }
        );
    entries.set(key, next);
    return next.promise;
};

export const clearInFlight = () => entries.clear();
